var _rect, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudiolyrics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 89,
    viewBox: "0 0 117 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 89,
    rx: 11,
    fill: "url(#paint0_linear_4423_138)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4322 54.1482C34.5106 41.0428 33.6312 25.668 38.7169 12.4998C52.7401 14.1175 65.9444 22.0424 73.866 35.1478C81.7876 48.2531 82.667 63.6279 77.5813 76.7962C63.5581 75.1784 50.3538 67.2535 42.4322 54.1482Z",
    fill: "url(#paint1_linear_4423_138)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9814 33.8401L70.4615 41.2201L58.9814 48.6002V33.8401Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.667 58.1668V28.5556L79.0004 24V53.6112",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8334 64.9999C48.6073 64.9999 51.6667 61.9405 51.6667 58.1665C51.6667 54.3926 48.6073 51.3332 44.8334 51.3332C41.0594 51.3332 38 54.3926 38 58.1665C38 61.9405 41.0594 64.9999 44.8334 64.9999Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1664 60.4444C75.9403 60.4444 78.9997 57.385 78.9997 53.6111C78.9997 49.8371 75.9403 46.7777 72.1664 46.7777C68.3924 46.7777 65.333 49.8371 65.333 53.6111C65.333 57.385 68.3924 60.4444 72.1664 60.4444Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4423_138",
    x1: 90,
    y1: 2.06977,
    x2: 23.1017,
    y2: 27.2607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC52F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4423_138",
    x1: 40.247,
    y1: 15.0312,
    x2: 76.0512,
    y2: 74.2648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF003D",
    stopOpacity: 0.03
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudiolyrics);
export default __webpack_public_path__ + "static/media/audiolyrics.302270fa540f99e040e753b21f5c412e.svg";
export { ForwardRef as ReactComponent };